var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[(!!_vm.artist.bio && _vm.artist.bio.length > 10)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.artist.bio)}}):_c('v-card-title',[_vm._v("No details available yet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }